<script>
import { Modal } from "bootstrap";
import PrincipalHeader from "@/views/pages/dashboard/principal/components/Principal-header.vue";
import PrincipalSidebar from "@/views/pages/dashboard/principal/components/Principal-sidebar.vue";
import BaseLoading from "@/components/CustomComponent/shared/Loading.vue";
import { useSharedStore } from "@/stores/shared-store";
import { useAuthStore } from "@/stores/auth-store";
import AddGroupModal from "@/components/CustomComponent/modal/add-group-modal.vue";
import { useCourseFetchStore } from "@/stores/course/course-fetch-store.js";
import { useCourseDataStore } from "@/stores/course/course-data-store.js";
import { onMounted } from "vue";
import Swal from 'sweetalert2';

export default {
  components: {
    PrincipalHeader,
    PrincipalSidebar,
    BaseLoading,
    AddGroupModal,
  },
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 10,
      pageWindowSize: 6,
    };
  },
  setup() {
    const sharedStore = useSharedStore();
    const authStore = useAuthStore();
    const courseFetchStore = useCourseFetchStore();
    const courseDataStore = useCourseDataStore();

    onMounted(() => {
      courseFetchStore.fetchGroupList();
    });
    return {
      sharedStore,
      authStore,
      courseFetchStore,
      courseDataStore,
    };
  },
  computed: {
    groupList() {
      return this.courseFetchStore.groupList || [];
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.groupList.length / this.itemsPerPage));
    },
    paginatedGroups() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.groupList.slice(start, end);
    },
    visiblePages() {
      const total = this.totalPages;
      const windowSize = this.pageWindowSize;
      if (total <= windowSize) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }
      const chunkStart =
        Math.floor((this.currentPage - 1) / windowSize) * windowSize + 1;
      const chunkEnd = Math.min(chunkStart + windowSize - 1, total);
      return Array.from(
        { length: chunkEnd - chunkStart + 1 },
        (_, i) => chunkStart + i
      );
    },
  },
  watch: {
    groupList() {
      if (this.currentPage > this.totalPages) {
        this.currentPage = this.totalPages;
      }
    },
  },
  methods: {
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    openAddGroupModal() {
      // Reset form
      this.courseDataStore.selectedGroupId = null;
      this.courseDataStore.resetCourseGroupForm();

      // Buka modal manual pakai Bootstrap API
      const modalEl = document.getElementById("addGroupModal");
      if (modalEl) {
        let modalInstance = Modal.getInstance(modalEl);
        if (!modalInstance) {
          modalInstance = new Modal(modalEl);
        }
        modalInstance.show();
      }
    },
    openEditGroup(group) {
      // Isi data form di store atau modal
      this.courseDataStore.selectedGroupId = group.course_group_id;
      this.courseDataStore.courseGroupForm = {
        code: group.code,
        name: group.name,
        description: group.description,
      };

      // Buka modal
      const modalEl = document.getElementById("addGroupModal");
      if (modalEl) {
        let modalInstance = Modal.getInstance(modalEl);
        if (!modalInstance) {
          modalInstance = new Modal(modalEl);
        }
        modalInstance.show();
      }
    },

    DeleteGroup(group) {
      if (this.sharedStore.loading) return;

      Swal.fire({
        title: "Are you sure you want to delete this group?",
        text: "This action cannot be undone!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          this.courseDataStore.deleteGroup(group);
        }
      });
    },
  },
};
</script>
<template>
  <layouts-header></layouts-header>
  <!-- Breadcrumb -->
  <div class="breadcrumb-bar text-center">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-12">
          <h2 class="breadcrumb-title mb-2">Course Group</h2>
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb justify-content-center mb-0">
              <li class="breadcrumb-item">
                <router-link to="/home">Home</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Course Group
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
  <!-- /Breadcrumb -->
  <div class="content">
    <div class="container">
      <PrincipalHeader
        v-if="authStore.role.toLowerCase() === 'principal'"
      ></PrincipalHeader>
      <instructor-header v-else></instructor-header>
      <div class="row">
        <PrincipalSidebar
          v-if="authStore.role.toLowerCase() === 'principal'"
        ></PrincipalSidebar>
        <instructor-sidebar v-else></instructor-sidebar>
        <div class="col-lg-9">
          <div class="col-md-12 text-center" v-if="sharedStore.loading">
            <BaseLoading :dialog="false"></BaseLoading>
          </div>
          <div v-else>
            <div
              class="page-title d-flex align-items-center justify-content-between"
            >
              <h5 class="fw-bold">Course Group</h5>
              <button
                type="button"
                class="btn btn-secondary"
                @click="openAddGroupModal"
              >
                Add Group
              </button>
            </div>
            <div class="table-responsive custom-table">
              <table class="table">
                <thead class="thead-light">
                  <tr>
                    <th>Code</th>
                    <th>Name</th>
                    <th>Description</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="groupList.length === 0">
                    <td class="text-center" colspan="4">No Data</td>
                  </tr>
                  <tr
                    v-for="(item, index) in paginatedGroups"
                    :key="item.course_group_id || index"
                  >
                    <td>
                      <div class="course-title d-flex align-items-center">
                        <p class="course-title">
                          {{ item.code }}
                        </p>
                      </div>
                    </td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.description }}</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <a
                          href="#"
                          class="d-inline-flex fs-14 me-1 action-icon"
                          @click.prevent="openEditGroup(item)"
                          ><i class="isax isax-edit-2"></i
                        ></a>
                        <a
                          href="#"
                          class="d-inline-flex fs-14 action-icon"
                          :class="{ disabled: sharedStore.loading }"
                          @click.prevent="DeleteGroup(item)"
                          ><i class="isax isax-trash"></i
                        ></a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              class="row align-items-center mt-4"
              v-if="groupList.length > 0"
            >
              <div class="col-md-2">
                <p class="fs-14 fw-500 text-center text-md-start">
                  Page {{ currentPage }} of {{ totalPages }}
                </p>
              </div>
              <div class="col-md-10">
                <ul
                  class="pagination lms-page justify-content-center justify-content-md-end mt-2 mt-md-0"
                >
                  <li
                    class="page-item prev"
                    :class="{ disabled: currentPage === 1 }"
                  >
                    <a
                      class="page-link"
                      href="javascript:void(0)"
                      tabindex="-1"
                      @click="goToPage(currentPage - 1)"
                      ><i class="fas fa-angle-left"></i
                    ></a>
                  </li>
                  <li
                    class="page-item"
                    :class="{ active: currentPage === page }"
                    v-for="page in visiblePages"
                    :key="page"
                  >
                    <a
                      class="page-link"
                      href="javascript:void(0)"
                      @click="goToPage(page)"
                      >{{ page }}</a
                    >
                  </li>
                  <li
                    class="page-item next"
                    :class="{ disabled: currentPage === totalPages }"
                  >
                    <a
                      class="page-link"
                      href="javascript:void(0)"
                      @click="goToPage(currentPage + 1)"
                      ><i class="fas fa-angle-right"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <AddGroupModal />
</template>
